import { Card, CardContent } from '@zaogig/ui/card';
import { Badge } from '@zaogig/ui/badge';
import { Textarea } from '@zaogig/ui/textarea';
import { Button } from '@zaogig/ui/button';
import { MapPin } from 'lucide-react';
import type { TaskQuestionResponse } from '../../hooks/use-attendance-state';

interface CheckInQuestionPhaseProps {
  question: TaskQuestionResponse;
  answer: string;
  onAnswerChange: (answer: string) => void;
  onSubmit: () => void;
  onCancel: () => void;
  location?: { lat: number; lng: number } | null;
  isSubmitting?: boolean;
}

export function CheckInQuestionPhase({
  question,
  answer,
  onAnswerChange,
  onSubmit,
  onCancel,
  location,
  isSubmitting = false
}: CheckInQuestionPhaseProps) {
  return (
    <div className="flex flex-col min-h-[60vh] px-6 py-4">
      <div className="mb-6">
        <h2 className="text-lg font-bold text-gray-800 mb-2">请回答任务问题</h2>
        <p className="text-gray-500 text-sm">
          回答问题以确认您了解今天的工作内容
        </p>
      </div>

      <Card className="mb-6">
        <CardContent className="p-4">
          <p className="font-medium text-gray-800">{question.question}</p>
          {question.expectedKeywords && question.expectedKeywords.length > 0 && (
            <div className="mt-3 flex flex-wrap gap-2">
              {question.expectedKeywords.map((keyword, idx) => (
                <Badge key={idx} variant="secondary" className="bg-gray-100 text-gray-600">
                  {keyword}
                </Badge>
              ))}
            </div>
          )}
        </CardContent>
      </Card>

      <div className="mb-6">
        <label className="block text-sm font-medium text-gray-700 mb-2">
          您的回答
        </label>
        <Textarea
          value={answer}
          onChange={(e) => onAnswerChange(e.target.value)}
          placeholder="请描述您今天的工作内容..."
          className="min-h-[120px] resize-none"
          disabled={isSubmitting}
        />
      </div>

      {location && (
        <div className="mb-6 flex items-center gap-2 text-sm text-gray-500">
          <MapPin className="w-4 h-4" />
          <span>位置已获取</span>
        </div>
      )}

      <div className="mt-auto space-y-3">
        <Button
          onClick={onSubmit}
          className="w-full bg-blue-600 hover:bg-blue-700"
          disabled={!answer.trim() || isSubmitting}
        >
          {isSubmitting ? '提交中...' : '提交并打卡'}
        </Button>
        <Button
          variant="outline"
          onClick={onCancel}
          className="w-full"
          disabled={isSubmitting}
        >
          取消
        </Button>
      </div>
    </div>
  );
}
